import fvSubassembly from "../fvSubassembly"
export default class fvPipeObj extends fvSubassembly {
    constructor(sContent, parent, system, callback) {
        super(sContent, parent, system);
        this.PIPE_JOIN_ADD_PT = 8;
        this.SIN_COS_PI = 3.1415926535897;
        if (this.lineType && this.lineType === -1) {
            this.insideColor = "#ff0000";
            //    this.outsideColor = "#847b6c";
            this.outsideColor = this.borderColor;
            this.colorStyle = 1;
        }
        this.initPoints = JSON.parse(JSON.stringify(this.points));
        this.create();
        if (this.isDelayedWaiting) {
            this.complete = callback;
        } else {
            callback(this);
        }
        this.createSucss();
        this.isHide = true;
        if(this.animation.fvHide){
            this.isHide = false;
        }
    }
    FcPt() {
        return {
            x: 0,
            y: 0
        };
    }
    GetOffset(parm) {
        if (this.lightMode == "(middle") {
            parm.faddx = 0; parm.faddy = 0.0;
        } else if (this.lightMode == "left") {
            parm.faddx = -0.25; parm.faddy = 0.0;
        } else if (this.lightMode == "right") {
            parm.faddx = 0.25; parm.faddy = 0.0;
        } else if (this.lightMode == "top") {
            parm.faddx = 0.0; parm.faddy = -0.25;
        } else if (this.lightMode == "bottom") {
            parm.faddx = 0.0; parm.faddy = 0.25;
        } else if (this.lightMode == "leftTop") {
            parm.faddx = -0.25; parm.faddy = -0.25;
        } else if (this.lightMode == "leftBottom") {
            parm.faddx = -0.25; parm.faddy = 0.25;
        } else if (this.lightMode == "rightBottom") {
            parm.faddx = 0.25; parm.faddy = 0.25;
        } else if (this.lightMode == "rightTop") {
            parm.faddx = 0.25; parm.faddy = -0.25;
        } else {
            parm.faddx = 0; parm.faddy = 0.0;
        }
    }

    AddJoinPoint(parm, PT0, m_points) {
        var fJoinWidth = parseInt(this.headSize);
        var fLen1;	//第一点和第二点之间的距离
        var fLen2;	//第二点和第三点之间的距离
        //判断圆角是否太大
        fLen1 = Math.sqrt(
            (PT0.x - m_points[0].x) * (PT0.x - m_points[0].x) +
            (PT0.y - m_points[0].y) * (PT0.y - m_points[0].y)
        );
        if (fJoinWidth > fLen1 / 2)
            fJoinWidth = fLen1 / 2;
        fLen2 = Math.sqrt(
            (m_points[0].x - m_points[1].x) * (m_points[0].x - m_points[1].x) +
            (m_points[0].y - m_points[1].y) * (m_points[0].y - m_points[1].y));
        if (fJoinWidth > fLen2 / 2)
            fJoinWidth = fLen2 / 2;
        if (fJoinWidth > 1.1) {
            var fTempPT = this.FcPt();
            var tempPT = this.FcPt();

            function GetCutPoint(Pt1, Pt2, tempParm) {
                var resultPt = this.FcPt();//fLineLen 绝不会为0
                resultPt.x = Pt2.x - (Pt2.x - Pt1.x) * tempParm.fJoinWidth / tempParm.fLen;
                resultPt.y = Pt2.y - (Pt2.y - Pt1.y) * tempParm.fJoinWidth / tempParm.fLen;
                return resultPt;
            }
            var tempParm = {};
            tempParm.fJoinWidth = parseInt(this.headSize);
            if ((this.cornerMode == "rs") || (this.cornerMode == "ss")) {
                tempParm.fLen = fLen1;
                fTempPT = GetCutPoint.call(this, PT0, m_points[0], tempParm);
                tempPT.x = fTempPT.x;
                tempPT.y = fTempPT.y;
                parm.pPotPtr[parm.nCount] = {};
                parm.pPotPtr[parm.nCount].x = tempPT.x;
                parm.pPotPtr[parm.nCount].y = tempPT.y;
                parm.nCount++;

                tempParm.fLen = fLen2;
                fTempPT = GetCutPoint.call(this, m_points[1], m_points[0], tempParm);
                tempPT.x = fTempPT.x;
                tempPT.y = fTempPT.y;
                parm.pPotPtr[parm.nCount] = {};
                parm.pPotPtr[parm.nCount].x = tempPT.x;
                parm.pPotPtr[parm.nCount].y = tempPT.y;
                parm.nCount++;
                return;
            }
            //圆滑连接
            var PT1 = this.FcPt();
            var PT2 = this.FcPt();

            tempParm.fLen = fLen1;
            PT1 = GetCutPoint.call(this, PT0, m_points[0], tempParm);
            tempParm.fLen = fLen2;
            PT2 = GetCutPoint.call(this, m_points[1], m_points[0], tempParm);

            var fLen = (Math.sqrt((PT1.x - PT2.x) * (PT1.x - PT2.x) + (PT1.y - PT2.y) * (PT1.y - PT2.y)));

            if (fLen < 4) {	//两点太接近，取其中点
                tempPT.x = int((PT1.x + PT2.x) / 2);
                tempPT.y = int((PT1.y + PT2.y) / 2);
                parm.pPotPtr[parm.nCount] = {};
                parm.pPotPtr[parm.nCount].x = tempPT.x;
                parm.pPotPtr[parm.nCount].y = tempPT.y;
                parm.nCount++;
                return;
            } else {
                var nXoff = Math.abs((PT1.x) - m_points[0].x) + Math.abs((PT2.x) - m_points[0].x);
                var nYoff = Math.abs((PT1.y) - m_points[0].y) + Math.abs((PT2.y) - m_points[0].y);
                if (nXoff < 2 || nYoff < 2) {
                    tempPT.x = int((PT1.x + PT2.x) / 2);
                    tempPT.y = int((PT1.y + PT2.y) / 2);
                    parm.pPotPtr[parm.nCount] = {};
                    parm.pPotPtr[parm.nCount].x = tempPT.x;
                    parm.pPotPtr[parm.nCount].y = tempPT.y;
                    parm.nCount++;
                    return;
                }
                tempPT.x = (PT1.x);
                tempPT.y = (PT1.y);
                parm.pPotPtr[parm.nCount] = {};
                parm.pPotPtr[parm.nCount].x = tempPT.x;
                parm.pPotPtr[parm.nCount].y = tempPT.y;
                parm.nCount++;

                var PCent = this.FcPt();

                function GetCirCent(Cent, PT1, PT, PT2) {
                    if (Math.abs(PT.y - PT1.y) < 0.00001) {
                        if (Math.abs(PT.x - PT2.x) < 0.00001) {
                            Cent.x = parseFloat(PT1.x);
                            Cent.y = parseFloat(PT2.y);
                            return true;
                        }
                        Cent.x = (PT1.x);
                        Cent.y = (PT.x - PT2.x) * (PT2.x - PT1.x) / (PT.y - PT2.y) + PT2.y;
                        return true;
                    }
                    else if (Math.abs(PT2.y - PT.y) < 0.00001) {
                        if (Math.abs(PT.x - PT1.x) < 0.00001) {
                            Cent.x = (PT2.x);
                            Cent.y = (PT1.y);
                            return true;
                        }
                        Cent.x = (PT2.x);
                        Cent.y = (PT.x - PT1.x) * (PT1.x - PT2.x) / (PT.y - PT1.y) + PT1.y;
                        return true;
                    }
                    var fK1, fK2;//直线1和2的斜率和截距
                    var fB1, fB2;
                    fK1 = (PT1.x - PT.x) / (PT.y - PT1.y);
                    fB1 = PT1.y - fK1 * PT1.x;
                    fK2 = (PT2.x - PT.x) / (PT.y - PT2.y);
                    fB2 = PT2.y - fK2 * PT2.x;
                    if (Math.abs(fK1 - fK2) < 0.0001) {
                        return false;
                    }
                    Cent.x = (fB2 - fB1) / (fK1 - fK2);
                    Cent.y = Cent.x * fK1 + fB1;
                    return true;
                }

                if (GetCirCent(PCent, PT1, m_points[0], PT2)) {
                    fLen = (Math.sqrt((PT1.x - PCent.x) * (PT1.x - PCent.x) + (PT1.y - PCent.y) * (PT1.y - PCent.y)));
                    var fLentemp = (Math.sqrt((PT2.x - PCent.x) * (PT2.x - PCent.x) + (PT2.y - PCent.y) * (PT2.y - PCent.y)));
                    var fCos = (PT1.x - PCent.x) / fLen;
                    if (fCos > 1.0)
                        fCos = 1.0;
                    else if (fCos < -1.0)
                        fCos = -1.0;
                    var fRBegin = (Math.acos(fCos));
                    if (PCent.y < PT1.y)
                        fRBegin = this.SIN_COS_PI * 2 - fRBegin;
                    fCos = (PT2.x - PCent.x) / fLen;
                    if (fCos > 1.0)
                        fCos = 1.0;
                    else if (fCos < -1.0)
                        fCos = -1.0;
                    var fREnd = (Math.acos(fCos));
                    if (PCent.y < PT2.y)
                        fREnd = this.SIN_COS_PI * 2 - fREnd;
                    if (Math.abs(fRBegin - fREnd) > this.SIN_COS_PI) {
                        if (fRBegin > fREnd)
                            fRBegin -= this.SIN_COS_PI * 2;
                        else
                            fREnd -= this.SIN_COS_PI * 2;
                    }
                    var fRAdd = (fRBegin - fREnd) / (this.PIPE_JOIN_ADD_PT - 1);
                    for (var i = 1; i < this.PIPE_JOIN_ADD_PT - 1; i++) {
                        tempPT.x = (PCent.x + fLen * Math.cos(fRBegin - fRAdd * i) + 0.5);
                        tempPT.y = (PCent.y - fLen * Math.sin(fRBegin - fRAdd * i) + 0.5);
                        parm.pPotPtr[parm.nCount] = {};
                        parm.pPotPtr[parm.nCount].x = tempPT.x;
                        parm.pPotPtr[parm.nCount].y = tempPT.y;
                        parm.nCount++;
                    }
                } else {
                    tempPT.x = ((PT1.x + PT2.x) / 2.0);
                    tempPT.y = ((PT1.y + PT2.y) / 2.0);
                    parm.pPotPtr[parm.nCount] = {};
                    parm.pPotPtr[parm.nCount].x = tempPT.x;
                    parm.pPotPtr[parm.nCount].y = tempPT.y;
                    parm.nCount++;
                }
                tempPT.x = (PT2.x);
                tempPT.y = (PT2.y);
                parm.pPotPtr[parm.nCount] = {};
                parm.pPotPtr[parm.nCount].x = tempPT.x;
                parm.pPotPtr[parm.nCount].y = tempPT.y;
                parm.nCount++;
            }
        }
        else {
            parm.pPotPtr[parm.nCount] = {};
            parm.pPotPtr[parm.nCount].x = m_points[0].x;
            parm.pPotPtr[parm.nCount].y = m_points[0].y;
            parm.nCount++;
        }
    }

    GetPtr(parm) {
        //临时代码，只实现了方头方拐角
        parm.nCount = this.points.length;
        parm.pPotPtr = new Array(parm.nCount);//备份点信息
        for (var i = 0; i < parm.nCount; i++) {
            parm.pPotPtr[i] = {};
            parm.pPotPtr[i].x = this.m_points[i].x;
            parm.pPotPtr[i].y = this.m_points[i].y;
        }
        //以下代码有圆头圆拐角有bug需要修改
        if (this.points.length < 3 || this.headSize == 0) {
            parm.nCount = this.points.length;
            parm.pPotPtr = new Array(parm.nCount);//备份点信息
            for (var i = 0; i < parm.nCount; i++) {
                parm.pPotPtr[i] = {};
                parm.pPotPtr[i].x = this.m_points[i].x;
                parm.pPotPtr[i].y = this.m_points[i].y;
            }
        }
        else {
            var nAddPtCnt;
            if ((this.cornerMode == "rs") || (this.cornerMode == "ss"))
                nAddPtCnt = 2;
            else
                nAddPtCnt = this.PIPE_JOIN_ADD_PT;
            parm.nCount = (this.points.length - 2) * nAddPtCnt + 2;
            parm.pPotPtr = new Array(parm.nCount);
            parm.nCount = 0;
            parm.pPotPtr[parm.nCount] = {};
            parm.pPotPtr[parm.nCount].x = this.m_points[0].x;
            parm.pPotPtr[parm.nCount].y = this.m_points[0].y;
            parm.nCount++;

            for (var i = 1; i < this.points.length - 1; i++) {
                var tempPts = [];
                tempPts.push(this.m_points[i]);
                tempPts.push(this.m_points[i + 1]);
                this.AddJoinPoint(parm, parm.pPotPtr[parm.nCount - 1], tempPts);
            }
            parm.pPotPtr[parm.nCount] = {};
            parm.pPotPtr[parm.nCount].x = this.m_points[this.points.length - 1].x;
            parm.pPotPtr[parm.nCount].y = this.m_points[this.points.length - 1].y;
            parm.nCount++;
        }
    }

    getPenStyle(canvas) {
        if (this.cornerMode == "rr") {
            canvas.lineCap = 'round';
            canvas.lineJoin = 'round';
        } else if (this.cornerMode == "rs") {
            canvas.lineCap = 'round';
            canvas.lineJoin = 'miter';
        } else if (this.cornerMode == "sr") {
            //设置lineCap square 出现偏差，采用默认butt
            canvas.lineCap = 'butt';
            canvas.lineJoin = 'round';
        } else if (this.cornerMode == "ss") {
            // canvas.lineCap = 'square';
            // canvas.lineJoin = 'miter';
        }
    }
    init() {
        super.init();
        this.borderWidth = this.borderWidth < 1 ? 1 : this.borderWidth;
        // 根据x y 因边框、缩放改变导致绘制管道重新计算
        for (var i = 0; i < this.points.length; i++) {
            var points0 = this.initPoints[i][0] + this.initPoints[i][0] * this.frameScaleX;
            var points1 = this.initPoints[i][1] + this.initPoints[i][1] * this.frameScaleY;
            this.points[i][0] = parseFloat(points0 * this.magnification.x);
            this.points[i][1] = parseFloat(points1 * this.magnification.y);
        }
        this.temp = parseFloat(this.borderWidth / 2);
        this.m_points = [];
        for (var i = 0; i < this.points.length; i++) {
            this.m_points.push({
                x: (parseFloat(this.points[i][0]) + this.temp),
                y: (parseFloat(this.points[i][1]) + this.temp)
            });
        }
    }
    onDraw(canvas) {
        this.setCanvas(canvas)
        if(!this.isHide) return;
        if(!this.fcHide) return;
        this.formatRect();
        canvas.save();
        canvas.setLineDash(this.lineStyle(this.lineType));
        this.executePreAnimation(canvas);
        var byR0, byG0, byB0;
        var nR1, nG1, nB1;
        var Color = [];

        var rgbArr = [];
        rgbArr = this.outsideColor.colorRgb();//获取第一种颜色
        if (rgbArr.length != 3) {
            byR0 = 0;
            byG0 = 0;
            byB0 = 255;
        } else {
            byR0 = rgbArr[0];
            byG0 = rgbArr[1];
            byB0 = rgbArr[2];
        }
        if (this.colorStyle == 1) {//一种色彩
            nR1 = byR0 + (255 - byR0) / 8 + byR0 / 2;
            nG1 = byG0 + (255 - byG0) / 8 + byG0 / 2;
            nB1 = byB0 + (255 - byB0) / 8 + byB0 / 2;

            if (nR1 > 255) {
                nR1 = 255;
            }
            if (nG1 > 255) {
                nG1 = 255;
            }
            if (nB1 > 255) {
                nB1 = 255;
            }
            byR0 = byR0 / 2;
            byG0 = byG0 / 2;
            byB0 = byB0 / 2;
        } else {//两种色彩
            var rgbArrTwo = [];
            //获取第二种颜色
            rgbArrTwo = this.insideColor.colorRgb();
            nR1 = rgbArrTwo[0];
            nG1 = rgbArrTwo[1];
            nB1 = rgbArrTwo[2];
        }
        var fAddR, fAddG, fAddB;
        //获取线宽
        var w = Math.max(1, parseInt(this.borderWidth));
        fAddR = (nR1 - byR0) / w;
        fAddG = (nG1 - byG0) / w;
        fAddB = (nB1 - byB0) / w;
        var faddx, faddy;
        var parm = {};
        parm.faddx = faddx;
        parm.faddy = faddy;
        parm.faddx = 0; parm.faddy = 0.0;
        //parm.push(faddx);
        //parm.push(faddy);
        this.GetOffset(parm);

        faddx = parm.faddx;
        faddy = parm.faddy;

        var nPenStyle;

        var nCount;
        var pPotPtr = [];

        var tempParm = {};
        tempParm.nCount = nCount;
        tempParm.pPotPtr = pPotPtr;

        this.GetPtr(tempParm);

        nCount = tempParm.nCount;
        pPotPtr = tempParm.pPotPtr;

        var nBakCount = tempParm.nCount;
        var pPotBak = new Array(nBakCount);
        var i = 0;
        for (; i < nBakCount; i++) {//备份点的信息
            pPotBak[i] = {};
            pPotBak[i].x = pPotPtr[i].x;
            pPotBak[i].y = pPotPtr[i].y;
        }

        var bUsePath = 1;//IfUsePath(this.cornerMode);
        var fWidthAdd;
        if (parseInt(this.borderWidth) <= 8) {
            fWidthAdd = 2.0;
        } else {
            fWidthAdd = 2.0 * parseInt(this.borderWidth) / 32.0 + 2.0;
        }
        i = -999;
        for (var fj = 1.0; fj <= parseInt(this.borderWidth); fj += fWidthAdd) {
            if ((i == Math.ceil(fj)) || (i + 1 == Math.ceil(fj)))
                continue;
            i = Math.ceil(fj);//这三行代码保证只有在线宽差距较大时才画，提高了效率

            var colorStyle = "rgb(";
            var tempr = byR0 + fAddR * i > 255 ? 255 : byR0 + fAddR * i;
            var tempg = byG0 + fAddG * i > 255 ? 255 : byG0 + fAddG * i;
            var tempb = byB0 + fAddB * i > 255 ? 255 : byB0 + fAddB * i;
            colorStyle += Math.ceil(tempr) + "," + Math.ceil(tempg) + "," + Math.ceil(tempb) + ")";
            canvas.strokeStyle = colorStyle//"rgb(0,0,0)";1df01d
            this.getPenStyle(canvas);
            canvas.lineWidth = parseInt(this.borderWidth) + 1 - i;
            for (var j = 0; j < nCount; j++) {
                pPotPtr[j].x = pPotBak[j].x + /*ddddcount*10 +*/ Math.ceil(faddx * i);
                pPotPtr[j].y = pPotBak[j].y + Math.ceil(faddy * i);
            }
            this.DrawPolyline(canvas, pPotPtr, nCount);
        }
        this.Render(canvas);

        this.executePosAnimation(canvas);
        canvas.restore();
    }
    DrawPolyline(canvas, pPotPtr, nCount) {
        // 清除undefined empty项
        this.pPotPtr = pPotPtr.filter(d => d);
        canvas.beginPath();
        canvas.moveTo(this.cx + this.pPotPtr[0].x, this.cy + this.pPotPtr[0].y);
        for (var i = 1; i < this.pPotPtr.length; i++) {
            canvas.lineTo(this.cx + this.pPotPtr[i].x, this.cy + this.pPotPtr[i].y);
        }
        canvas.stroke();
    }
}



// WEBPACK FOOTER //
// ./src/js/canvas/subUnit/fvPipeObj.js